/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const analyticsPaginationMetaDataSchema = z.object({
	currentPage: z.number(),
	lastPage: z.number(),
	perPage: z.number(),
	total: z.number(),
})

export type AnalyticsPaginationMetaDataSchema = z.infer<typeof analyticsPaginationMetaDataSchema>
